// Configuration statique de l'Espace Partenaire — libellés d'interface et catalogues de prestations
// (aucune donnée métier factice : ni prospects, ni clients, ni projets, ni chiffres).
export const PROSPECT_STATUSES = ["Nouveau", "À contacter", "RDV prévu", "Proposition envoyée", "Gagné", "Perdu"];

export const MOE_PHASES = [
  "Découverte",
  "Conception",
  "Plans & démarches",
  "Consultation des entreprises",
  "Préparation chantier",
  "Chantier",
  "Réception",
  "Terminé",
];

export const SMALL_STEPS = ["Demande client", "Visite / métrés", "Besoin", "Artisan", "Devis", "Accepté", "Travaux", "Facture", "Terminé"];

export const SERVICES = [
  { id: "plans", title: "Plans", desc: "Plans d'état des lieux, plans projet, plans de vente et coupes cotées.", lead: "5 à 10 jours" },
  { id: "dp", title: "Déclaration préalable", desc: "Constitution complète du dossier de déclaration préalable de travaux.", lead: "10 à 15 jours" },
  { id: "pc", title: "Permis de construire", desc: "Dossier de permis de construire avec pièces graphiques et notice.", lead: "3 à 5 semaines" },
  { id: "3d", title: "Visuels 3D", desc: "Perspectives 3D intérieures ou extérieures pour présenter le projet au client.", lead: "5 à 8 jours" },
  { id: "packs", title: "Packs techniques", desc: "Packs combinés plans + démarches + 3D pour les projets complets.", lead: "Selon pack" },
  { id: "autres", title: "Autres prestations techniques", desc: "Métrés, descriptifs, estimatifs détaillés, assistance à la consultation.", lead: "Sur demande" },
];

export const SERVICE_FLOW = ["Sélection du projet", "Choix du service", "Informations nécessaires", "Commande", "Paiement", "Production", "Livraison"];

export const DIGITAL_TOOLS = [
  { id: "sig", title: "Signature email", desc: "Signature personnalisée aux couleurs CozyHome avec vos coordonnées." },
  { id: "social", title: "Supports réseaux sociaux", desc: "Visuels prêts à publier : avant/après, conseils, annonces." },
  { id: "flyers", title: "Flyers numériques", desc: "Flyers PDF à partager par email ou messagerie." },
  { id: "pres", title: "Présentations", desc: "Présentation de l'offre CozyHome à remettre en rendez-vous." },
  { id: "docs", title: "Documents client", desc: "Modèles de courriers, comptes rendus et fiches projet." },
];

export const SHOP_ITEMS = [
  { id: "cards", title: "Cartes de visite", desc: "Impression premium, recto-verso." },
  { id: "pflyers", title: "Flyers imprimés", desc: "Formats A5 / A6, papier épais." },
  { id: "folders", title: "Chemises", desc: "Chemises à rabats pour vos dossiers clients." },
  { id: "signs", title: "Panneaux chantier", desc: "Panneaux extérieurs personnalisables." },
  { id: "paper", title: "Papeterie", desc: "Blocs, enveloppes et papier à en-tête." },
];

export const DOC_STATUSES = ["À fournir", "En vérification", "Validé", "Refusé", "Expiré"];

export const euro = (n) => new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n);
